// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SimpleIntakeContactPhonesModel {
    static getAttributeTypeMap() {
        return SimpleIntakeContactPhonesModel.attributeTypeMap;
    }
}
SimpleIntakeContactPhonesModel.discriminator = undefined;
SimpleIntakeContactPhonesModel.additionalProperties = false;
SimpleIntakeContactPhonesModel.attributeTypeMap = [
    {
        "name": "fax",
        "baseName": "fax",
        "type": "SimpleIntakePhoneModel"
    },
    {
        "name": "main",
        "baseName": "main",
        "type": "SimpleIntakePhoneModel"
    },
];
//# sourceMappingURL=simpleIntakeContactPhonesModel.js.map